import { BreadcrumbSubBar } from '@components/BreadcrumbSubBar';
import { BasePage } from './bases/BasePage';
import { useStyles } from './styles/Organizations.styles';
import { Typography } from '@mui/material';
import { Hint } from '@components/Hint';

import { OrgNav } from '@components/OrgNav';

export const Organizations = () => {
    const classes = useStyles();

    return (
        <BasePage>
            <BreadcrumbSubBar />
            <div className={classes.root}>
                <Typography className={classes.title}>Organizations</Typography>
                <Hint text='Navigate companies, locations, and resellers by expanding the dropdowns.' />
                <OrgNav />
            </div>
        </BasePage>
    );
};
